import { useParams } from 'react-router-dom';

import { DelegateProvider } from 'contexts/delegate.context';
import SinglePage from 'components/single-page/single-page';

const DelegateSinglePage = () => {
  const { name } = useParams();

  return (
    <DelegateProvider>
      <SinglePage name={name} />
    </DelegateProvider>
  );
};

export default DelegateSinglePage;
